import React, { useEffect, useState } from 'react';
import { IAttachAuditionMedia, IAuditionMedia } from 'shared/interfaces/IAudition';
import { useStyles } from '../SelfTapes.styles';
import { Box, Grid, Hidden } from '@material-ui/core';
import UploadingItem from '../UploadingItem';
import { Warning } from '@material-ui/icons';
import { COLORS } from 'shared/constants/COLORS';
const { WARNING_ICON, LIGHT_GREEN_ICON } = COLORS;
import { CheckedCircleIcon, Typography } from '@room-match/shared-ui-components';
import { CustomTypography } from 'shared/elements/CustomTypography';

interface Props {
  media?: IAuditionMedia[];
  req: string[];
  multiple: boolean;
  mock: {
    icon: React.ReactElement;
    label: string;
    info: string;
  };
  bindMedia: (data: IAttachAuditionMedia) => void;
  deleteMedia: (id: string) => void;
  completed: boolean;
  type: 'Image' | 'Video' | 'Audio' | 'File' | 'Other Image';
  hasImage: boolean;
  hasVideo: boolean;
  hasAudio: boolean;
  sort: number;
  invalidFileFormat: (type: 'video' | 'audio' | 'image' | 'document' | 'invalid_image') => void;
  invalidImageOrientation: VoidFunction;
}

const Multiple: React.FC<Props> = ({
  media,
  mock,
  req,
  bindMedia,
  deleteMedia,
  completed,
  type,
  hasImage,
  hasVideo,
  hasAudio,
  multiple,
  sort,
  invalidFileFormat,
  invalidImageOrientation,
}) => {
  const classes = useStyles();

  const [uploadingTag, setUploadingTag] = useState<string[]>([]);
  const [complete, setComplete] = useState<boolean>(false);

  useEffect(() => {
    if (media) {
      setComplete(media.length >= req.length);
    }
  }, [media, req]);

  const removeTag = (tag: string) => {
    setUploadingTag((tags) => tags.filter((f) => f !== tag));
  };

  const addTag = (tag: string) => {
    setUploadingTag((tags) => [...tags, tag]);
  };

  const bindMediaWithModifiedSort = (data: IAttachAuditionMedia) => {
    bindMedia({ ...data, sort: sort + 1000 + (media || [])?.length });
  };
  const showInstruction = Boolean(type !== 'Audio') && Boolean(type !== 'File');

  return (
    <>
      <Grid item className={classes.cardItem}>
        <Grid item>{mock.icon} </Grid>
        <Grid item style={{ flex: 1 }}>
          <CustomTypography fontSize={15} fontWeight={600}>
            {mock.label}
          </CustomTypography>
          <CustomTypography fontSize={14} style={{ marginTop: -5 }}>
            {mock.info}
          </CustomTypography>
        </Grid>
        {showInstruction ? (
          <div style={{ display: 'flex', marginRight: 10, flex: 1 }}>
            <Warning style={{ color: WARNING_ICON, marginRight: 5, alignSelf: 'center' }} />
            <Hidden smDown>
              <CustomTypography fontSize={14} fontWeight={500}>
                Please follow the instructions above
              </CustomTypography>
            </Hidden>
            <Hidden mdUp>
              <CustomTypography fontSize={14} fontWeight={500}>
                Read above
              </CustomTypography>
            </Hidden>
          </div>
        ) : (
          <React.Fragment />
        )}
        <Grid item className={classes.buttonContainer}>
          {complete ? (
            <Box style={{ display: 'flex' }}>
              <CheckedCircleIcon htmlColor={LIGHT_GREEN_ICON} />
              <Typography className={classes.completedText} style={{ marginLeft: -5 }}>
                Completed
              </Typography>
            </Box>
          ) : (
            <React.Fragment />
          )}
        </Grid>
      </Grid>
      <Box className={classes.deleteCont}>
        {req.map((r, i) => (
          <UploadingItem
            invalidImageOrientation={invalidImageOrientation}
            invalidFileFormat={invalidFileFormat}
            media={media?.find((f) => f.attributes.tag_list.includes(r))}
            sort={sort + i}
            req
            label={r}
            i={mock}
            type={type}
            bindMedia={bindMedia}
            deleteMedia={deleteMedia}
            completed={complete}
            tag_list={[r, type]}
            hasImage={hasImage}
            hasVideo={hasVideo}
            hasAudio={hasAudio}
          />
        ))}
        {media
          ?.filter((f) => req.every((tag) => !f.attributes.tag_list.includes(tag)))
          .map((m) => (
            <UploadingItem
              invalidImageOrientation={invalidImageOrientation}
              invalidFileFormat={invalidFileFormat}
              sort={sort + (media || [])?.length + uploadingTag.length + 1}
              media={m}
              req
              label={m.attributes.tag_list[0]}
              i={mock}
              type={type}
              bindMedia={bindMediaWithModifiedSort}
              deleteMedia={deleteMedia}
              completed={complete}
              tag_list={m.attributes.tag_list}
              hasImage={hasImage}
              hasVideo={hasVideo}
              hasAudio={hasAudio}
            />
          ))}
        {multiple ? (
          <UploadingItem
            invalidImageOrientation={invalidImageOrientation}
            invalidFileFormat={invalidFileFormat}
            sort={sort + (media || [])?.length + uploadingTag.length + 1}
            media={media?.find((f) => f.attributes.tag_list.includes(''))}
            req
            label={''}
            i={mock}
            type={type}
            bindMedia={bindMediaWithModifiedSort}
            deleteMedia={deleteMedia}
            completed={complete}
            tag_list={[type, '']}
            hasImage={hasImage}
            hasVideo={hasVideo}
            hasAudio={hasAudio}
            multiple
            addTag={addTag}
            removeTag={removeTag}
          />
        ) : (
          <React.Fragment />
        )}
        {uploadingTag.map(() => (
          <UploadingItem
            invalidImageOrientation={invalidImageOrientation}
            invalidFileFormat={invalidFileFormat}
            sort={sort + (media || [])?.length + uploadingTag.length + 1}
            media={media?.find((f) => f.attributes.tag_list.includes(''))}
            req
            label={''}
            i={mock}
            type={type}
            bindMedia={bindMediaWithModifiedSort}
            deleteMedia={deleteMedia}
            completed={complete}
            tag_list={[type, '']}
            hasImage={hasImage}
            hasVideo={hasVideo}
            hasAudio={hasAudio}
            multiple
            addTag={addTag}
            removeTag={removeTag}
          />
        ))}
      </Box>
    </>
  );
};

export default Multiple;
